module.exports = __webpack_public_path__ + "img/potencia_r_c_gray.5cd0e9ba.svg";